import decoins_repository from "../../../../infrastructure/repository/impl/decoins/decoins_repository";
import DecoinInterface from "./decoinInterface";
import { DecoinLimit } from "../../../entities/decoins";
import { Order } from "../../../entities/order";

class DecoinUseCases implements DecoinInterface {
  async dailyDecoinLimit(): Promise<DecoinLimit> {
    return await decoins_repository.dailyDecoinLimit();
  }

  async decoinDailyLimitMessageAccepted(): Promise<void> {
    return await decoins_repository.decoinDailyLimitMessageAccepted();
  }

  async getPdfExtractDecoins(order: Order): Promise<string> {
    return await decoins_repository.getPdfExtractDecoins(order);
  }

  async getExcelExtractDecoins(order: Order): Promise<string> {
    return await decoins_repository.getExcelExtractDecoins(order);
  }
}

export default new DecoinUseCases() as DecoinInterface;
